import styled from "styled-components";

const Container = styled.div`
`;

const Wrapper = styled.div`
  display: grid;
  justify-content: center;
  padding: 30px clamp(20px, 3.194vw, 46px);
  background-color: #233354;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  align-items: flex-start;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  color: #ffffff;
  h4 {
    font-size: 16px;
    margin-bottom: 20px;
  }
  .social-icons{
    display: flex;
    gap: 12px;
  }
  li {
    font-size: 12px;
    line-height: 30px;
  }
  .margin-top{
    margin-top: 67px;
  }
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    .margin-top{
      margin-top: 0px;
    }
  }
`;

export { Container, Wrapper };
